export default __webpack_public_path__ + "static/media/cli-smf.e3ba4cc3.jpg";